import { createContext, useContext, useState } from "react";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [hayPendientes, setHayPendientes] = useState(false);
  const [hayCitasPendientes, setHayCitasPendientes] = useState(false);

  return (
    <NotificationContext.Provider
      value={{
        hayPendientes,
        setHayPendientes,
        hayCitasPendientes,
        setHayCitasPendientes,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
